import { render, staticRenderFns } from "./ModalFormularioSedeUniversidad.vue?vue&type=template&id=4eb7e593&scoped=true"
import script from "./ModalFormularioSedeUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioSedeUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioSedeUniversidad.vue?vue&type=style&index=0&id=4eb7e593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7e593",
  null
  
)

export default component.exports